import { Link } from 'react-router-dom';
import withA from './withA';
export default withA(Link);
//# sourceMappingURL=index.js.map